import { useCallback, useEffect } from "react";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import { Card, Text } from "@mantine/core";
import { PodcastList } from "./PodcastList";
import { ClampableText } from "../ClampableText";
import { useStores } from "@/hooks/useStores";

export const PodcastCollection = observer(({ slug }: PodcastCollectionProps) => {
    const { collectionStore } = useStores();

    const loadColl = useCallback(() => {
        collectionStore.loadCollection(slug).catch(console.error);
    }, [collectionStore, slug]);

    useEffect(() => {
        loadColl();
    }, [loadColl]);

    return collectionStore.loading ? (
        <div>Loading...</div>
    ) : (
        <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Text fw={500} size="lg">
                {collectionStore.collection?.name}
            </Text>
            <ClampableText text={collectionStore.collection?.content} contractAt={130} />

            {collectionStore.collection && <PodcastList flush podcasts={collectionStore.collection.podcasts} />}

            <Card.Section p="lg">
                <Link to={"/samling/" + collectionStore.collection?.slug}>Alla episoder</Link>
            </Card.Section>
        </Card>
    );
});
